export const importAllowedFileTypes = ['csv'];

export const importBusTypes = ['rsmcontributions', 'person'];